const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartModalClose: '.js-ajax-cart-modal-close', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.js-ajax-cart-counter', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    cartQtyPlus: '.ajax-cart-qty-plus', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button', //classname
    ajaxCartButton :'.ajax-cart-btn', //classname
  };
  
  const cartModal = document.querySelector(defaults.cartModal);
  const cartModalContent = document.querySelector(defaults.cartModalContent);
  const cartModalClose = document.querySelector(defaults.cartModalClose);
  const cartDrawer = document.querySelector(defaults.cartDrawer);
  const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
  const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
  const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
  const cartOverlay = document.querySelector(defaults.cartOverlay);
  const cartCounter = document.querySelector(defaults.cartCounter);
  const addToCart = document.querySelectorAll(defaults.addToCart);
  const cartQtyPlus =document.querySelectorAll(defaults.cartQtyPlus);
  let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
  const checkoutButton = document.querySelector(defaults.checkoutButton);
  let ajaxCartButton = document.querySelector(defaults.ajaxCartButton);
  const htmlSelector = document.documentElement;
  
  for (let i = 0; i < addToCart.length; i++) {
  
    addToCart[i].addEventListener('click', function(event) {
  
        event.preventDefault();
        const formID = this.parentNode.getAttribute('id');
        // console.log(formID);
        addProductToCart(formID);
   updateCount();
    });
  
  }
  
  function addProductToCart(formID, $this) {
    
    if($this && $this.hasClass("product-block__inner-v2")){
      $this.find(".product-block-hover").addClass("active");
      $this.find('.circle-loader').toggleClass('load-complete');
      $this.find('.circle-loader .checkmark').toggle();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: function(product){
          $this.find('.circle-loader .checkmark').toggle();
          $this.find('.circle-loader').toggleClass('load-complete');
          $this.find(".product-block-hover").removeClass("active");
          addToCartOk(product)
        },
        error: function(){
          $this.find('.circle-loader .checkmark').toggle();
          $this.find('.circle-loader').toggleClass('load-complete');
          $this.find(".product-block-hover").removeClass("active");
          addToCartFail()
        },
      });
    } else {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: addToCartOk,
        error: addToCartFail,
      });
    }

  }
  
  function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);
  
            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = 'Votre panier est vide';
                checkoutButton.classList.add('is-hidden');
                $(".cart_count").html("0")
                $(".ajax-cart-drawer-footer").hide();
              $(".ajax-cart-drawer-body").addClass("is-empty");
            } else {
                renderCart(cart);
                $(".ajax-cart-drawer-footer").show()
                checkoutButton.classList.remove('is-hidden');
                $(".ajax-cart-drawer-body").removeClass("is-empty");
            }
  
        },
    });
  }
  
  function changeItem(line, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart(cart);
            }
        },
    });
  }
  
  function onCartUpdate(cart) {
    var count = cart.item_count;
     if ( count <= 1  ){
            $(".cart_count-txt").text("article")
          }
          else{ $(".cart_count-txt").text("articles") }
    // console.log('items in the cart?', cart.item_count);
  }
  
  function addToCartOk(product) {
    cartModalContent.innerHTML = product.title + ' was added to the cart!';
    var Qty = $(".quantity__input").first().val();
    Qty = parseInt(Qty);
    // cartCounter.innerHTML = Number(cartCounter.innerHTML) + Qty;
    // $(".cart_count").text(Number(cartCounter.innerHTML));
    openCartDrawer();
    openAddModal();
    openCartOverlay();
    fetchCart();
  }
  
  function removeProductFromCart(cart) {
    // cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
   var Qty = $(".quantity__input").first().val();
    Qty = parseInt(Qty);
    Qty = Number(cartCounter.innerHTML) - Qty
    cartCounter.innerHTML =Number(cartCounter.innerHTML) - Qty;
    var cartCount = $(".js-ajax-cart-counter.cart_count").text();
    if(cart.item_count < 1){
      $(".js-ajax-cart-counter.cart_count").addClass("hide")
    }
    else{
      $(".js-ajax-cart-counter.cart_count").removeClass("hide")
    }
  }
  
  function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    openCartOverlay();
  }
  
  function renderCart(cart) {
  
    // console.log(cart);
    console.log("result is: " + cart.item_count);
    if(cart.item_count < 1){
      $(".js-ajax-cart-counter.cart_count").addClass("hide")
    }
    else{
      $(".js-ajax-cart-counter.cart_count").removeClass("hide")
    }
    $(".cart_count").html(cart.item_count)
  
    clearCartDrawer();
  
    cart.items.forEach(function(item, index) {
    var price = (item.line_price)/100;
    var _options ='';
    var _length = item.options_with_values.length;  
        const productTitle = '<div class="ajax-cart-item__title">' + item.product_title + '</div>';
      for (let i = 0; i < _length; i++) {
        //  = '<div class="ajax-cart-item__variants">' + _length + ":" + item.options_with_values[i].value + '</div>'; 
        _options += item.options_with_values[i].name + ": " + item.options_with_values[i].value + "<br>" ;
      }
      const productVariants ='<div class="ajax-cart-item__variants">'+ 'Prix unitaire: ' + theme.Shopify.formatMoney(item.price, theme.money_format_with_code_preference) + ' HT <br>' + _options + '</div>';
        const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" >';
        const productPrice = '<div class="ajax-cart-item__prices"><div class="ajax-cart-item__price">' + theme.Shopify.formatMoney(item.line_price, theme.money_format_with_code_preference)  + ' HT</div><div class="ajax-cart-item__TTprice">'  + theme.Shopify.formatMoney((item.line_price * 1.2), theme.money_format_with_code_preference)  +  ' TTC</div></div>';
        const productQuantity = '<div class="ajax-cart-buttons"><div class="ajax-cart-qty"><button class="ajax-cart-qty-minus ajax-cart-btn"><span>&#8722;</span></button> <input class="quantity__input-cart" type="number" name="quantity" id="Quantity-'+ Number(index + 1) +'" min="1" value="' + item.quantity + '" form="'+ Number(index + 1) +'" ><button class="ajax-cart-qty-plus  ajax-cart-btn"><span>&#43;</span></button></div><div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '">Supprimer</div></div>';
        const productRemove ='' ;
        const productQty = '';
        const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + '<div class="ajax-cart-item__content">' + productImage + '<div class="ajax-cart-item__titleQty">' + productTitle + productVariants + productQuantity + '</div>' + '</div>' + productPrice +  productRemove + '</div>';
  
        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
  
    });
  var total_price = theme.Shopify.formatMoney(cart['total_price'], theme.money_format_with_code_preference);
  $(".subtotal-price").text(total_price + " HT" );
    removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            const line = this.closest('.ajax-cart-item__single').getAttribute('data-line');
            // console.log(line);
            changeItem(line);
        });
    }
        ajaxCartButton = document.querySelectorAll(defaults.ajaxCartButton);
        for (let i = 0; i < ajaxCartButton.length; i++) {
            ajaxCartButton[i].addEventListener('click', function() {

                var qty = $(this).siblings(".quantity__input-cart").val();
                qty = parseInt(qty);
                if($(this).hasClass("ajax-cart-qty-plus")){
                    qty = qty + 1;
                    $(this).siblings(".quantity__input-cart").val(qty);  
                } else if($(this).hasClass("ajax-cart-qty-minus")){
                    if(qty > 0){
                        qty = qty - 1;
                        $(this).siblings(".quantity__input-cart").val(qty);
                    }
                }
        

                const line = $(this).parents(".ajax-cart-item__single").attr('data-line');
                var quantity = $(this).siblings(".quantity__input-cart").val();
                updateItem(line , quantity);
            });
        }
        $("input.quantity__input-cart").change(function(){
            const line = $(this).parents(".ajax-cart-item__single").attr('data-line');
            var quantity = this.value;
            updateItem(line , quantity);
        });
  }
  
  function openCartDrawer() {
    cartDrawer.classList.add('is-open');
  }
  
  function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
  }
  
  function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
  }
  
  function openAddModal() {
    cartModal.classList.add('is-open');
  }
  
  function closeAddModal() {
    cartModal.classList.remove('is-open');
  }
  
  function openCartOverlay() {
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
  }
  
  function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
  }
  
  cartModalClose.addEventListener('click', function() {
    closeAddModal();
    closeCartOverlay();
  });
  
  cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
  });
  // cart is empty stanje
  cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
  });
  
  cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
    //fetchCart();
    openCartDrawer();
    openCartOverlay();
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function(){
    fetchCart();
      },2000);
  });
  
//   jQuery(document).on('click', '.ajax-cart-qty-plus', function () {
//     var qty = $(this).siblings(".quantity__input-cart").val();
//     qty = parseInt(qty);
//     qty = qty + 1;
//       $(this).siblings(".quantity__input-cart").val(qty);
//     });
//  jQuery(document).on('click', '.ajax-cart-qty-minus', function () {
//  var qty = $(this).siblings(".quantity__input-cart").val();
//     qty = parseInt(qty);
//    if(qty > 0){
//     qty = qty - 1;
//     $(this).siblings(".quantity__input-cart").val(qty);
//      UpdateQty();
//    }
//     });
  function updateCount(){
    setTimeout(function(){
        $.getJSON('/cart.js', function(cart){ 
            var result = cart.item_count;
          console.log("result is: " + result);
           if(result < 1){
      $(".js-ajax-cart-counter.cart_count").addClass("hide")
    }
    else{
      $(".js-ajax-cart-counter.cart_count").removeClass("hide")
    }
          $(".cart_count").text(result);
        });
    },1000);
  }
 function updateItem(line,quantity, callback) {
    var quantity = quantity;
    // console.log("qty",quantity)
    // console.log("line",line)
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + parseInt(quantity) + '&line=' + parseInt(line),
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart(cart);
            }
        },
    });
}

$('.product__info-wrapper .select__select').on('change', function() {
  var val =  this.value;
    val = parseInt(val);
  // console.log("Value" + val);
  $('.sticky-cart .sticky_ATC_form .product-form__input select').val(val).change();;
});

